export default class Model
{
}